import { createSlice } from '@reduxjs/toolkit';

export const browserDetailsSlice = createSlice({
  name: 'browserDetails',
  initialState: {
    browserId: "",
  },
  reducers: {
    setBrowserDetails: (state, action) => {
      state.browserId = action.payload;
    },
  },
});

export const { setBrowserDetails } = browserDetailsSlice.actions;
export default browserDetailsSlice.reducer;